import { FLOW_HEX, FLOW_SHADOW, FLOW_VAR } from "src/theme/flowColorTokens";

/**
 * Açık yüzeyli select — JWT `--flow-text` açık renkte olsa bile seçili metin / yazı her zaman koyu (okunabilirlik).
 * Placeholder ikinci planda gri kalır.
 */
const SELECT_FIELD_TEXT = FLOW_HEX.ink;
const SELECT_PLACEHOLDER_TEXT = FLOW_HEX.muted;

/** Geriye dönük export (select sabit mürekkep; tema gövdesiyle karıştırma) */
export const FLOW_TEXT = SELECT_FIELD_TEXT;
export const FLOW_TEXT_MUTED = SELECT_PLACEHOLDER_TEXT;

export const customStyles = (errors = false) => ({
  control: (provided, state) => ({
    ...provided,
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    height: "52px",
    borderRadius: "1rem",
    padding: "4px 20px",
    cursor: "pointer",
    borderWidth: "1px",
    backgroundColor: FLOW_VAR.surface,
    borderColor: errors
      ? FLOW_VAR.danger
      : state.isFocused
        ? FLOW_VAR.accent
        : FLOW_VAR.border,
    boxShadow: "none",
    "&:hover": {
      borderColor: errors ? FLOW_VAR.danger : FLOW_VAR.borderHover,
    },
    "&:disabled": {
      cursor: "not-allowed",
      backgroundColor: FLOW_VAR.surface,
      color: SELECT_FIELD_TEXT,
      opacity: 0.5,
      borderColor: FLOW_VAR.borderDisabled,
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: SELECT_FIELD_TEXT,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: SELECT_PLACEHOLDER_TEXT,
  }),
  input: (provided) => ({
    ...provided,
    color: SELECT_FIELD_TEXT,
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "8px 16px",
    backgroundColor: state.isSelected
      ? FLOW_VAR.surfaceSelected
      : FLOW_VAR.surface,
    color: SELECT_FIELD_TEXT,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: FLOW_VAR.surfaceSelected,
    },
  }),
  menu: (provided) => ({
    ...provided,
    position: "absolute",
    width: "100%",
    maxHeight: "380px",
    zIndex: "10",
    marginTop: "0.25rem",
    borderRadius: "1rem",
    overflowY: "auto",
    backgroundColor: FLOW_VAR.surface,
    boxShadow: FLOW_SHADOW.menu,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: FLOW_VAR.surfaceSelectedSoft,
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: SELECT_FIELD_TEXT,
  }),
});
